export const sampleJson = `[
  {
    "vendorName": "Frelit Energy",
    "contactPersonName": "Executive",
    "contactPersonEmail": "info@frelitenergy.com",
    "contactPersonMobile": "9898252646",
    "address": "B-1208 World Trade Tower"
  },
  {
    "vendorName": "Adani Solar",
    "contactPersonName": "Executive",
    "contactPersonEmail": "info@adanisolar.com",
    "contactPersonMobile": "7966006600",
    "address": "At & Post: Tajpur, NH-8"
  }
]`;
